import { render, staticRenderFns } from "./SetToken.vue?vue&type=template&id=70f2df41&"
import script from "./SetToken.js?vue&type=script&lang=js&"
export * from "./SetToken.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports